import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function meaningfulTextValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (value === null || value === undefined || value === '') {
      return null;
    }

    const normalized = String(value).trim();

    if (!normalized) {
      return { whitespace: true };
    }

    return /[\p{L}\p{N}]/u.test(normalized)
      ? null
      : { meaningfulText: true };
  };
}

export function maxDecimalsValidator(maxDecimals: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    const normalized = String(control.value).trim().replace(',', '.');
    if (!/^-?\d+(\.\d+)?$/.test(normalized)) {
      return null;
    }

    const [, decimals = ''] = normalized.split('.');
    return decimals.length > maxDecimals
      ? { maxDecimals: { requiredDecimals: maxDecimals } }
      : null;
  };
}

export function endAfterStartValidator(
  startControlName: string,
  endControlName: string,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const startDate = control.get(startControlName)?.value;
    const endDate = control.get(endControlName)?.value;

    if (!startDate || !endDate) {
      return null;
    }

    return startDate <= endDate ? null : { endAfterStart: true };
  };
}
